// extracted by mini-css-extract-plugin
module.exports = {"testimonialCard":"styles-module--testimonialCard--31S1W","text":"styles-module--text--2sXgG","name":"styles-module--name--V-NYb","location":"styles-module--location--e6gxv"};